// extracted by mini-css-extract-plugin
export var emailBlockLink = "_n8-0";